import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";

const quickLinks = [
  { label: "Services", href: "#services" },
  { label: "Service Area", href: "#service-area" },
  { label: "About", href: "#about" },
  { label: "Book / Free Quote", href: "#booking" },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              Certified radon testing and engineered mitigation for Greater
              Boston and MetroWest homes. Locally owned since 2018.
            </p>
            <div className="mt-6 space-y-2.5 text-sm">
              <a
                data-testid="footer-phone-link"
                href="tel:+15089692104"
                className="flex items-center gap-2.5 text-white/80 transition-colors hover:text-gold-light"
              >
                <Phone className="h-4 w-4 text-gold" />
                (508) 969-2104
              </a>
              <a
                data-testid="footer-email-link"
                href="mailto:homedefensesolutionsllc@gmail.com"
                className="flex items-center gap-2.5 text-white/80 transition-colors hover:text-gold-light"
              >
                <Mail className="h-4 w-4 text-gold" />
                homedefensesolutionsllc@gmail.com
              </a>
              <p className="flex items-center gap-2.5 text-white/60">
                <MapPin className="h-4 w-4 text-gold" />
                625 Massachusetts Ave, Cambridge, MA 02139
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-light">
              Explore
            </p>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-white/70 transition-colors hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-light">
              Service area
            </p>
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              Boston neighborhoods including Back Bay, Beacon Hill, South End,
              Dorchester, Jamaica Plain, Charlestown and West Roxbury — plus
              Cambridge, Somerville, Brookline, Newton, Quincy, Medford,
              Waltham, Wellesley, Lexington, Framingham and surrounding
              MetroWest towns.
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-white/50">
            © 2026 Home Defense Solutions LLC. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            8 years of radon testing &amp; mitigation in Boston, MA — est. 2018
          </p>
        </div>
      </div>
    </footer>
  );
}
